import React, { useState } from "react";
import { Box, IconButton, Button, Tooltip, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useGridApiContext } from "@mui/x-data-grid-pro";
import { useNavigate } from "react-router-dom";

import SideModal from "../../../../components/SideModal";
import CompetencyPlaylistForm from "../../../Playlist/Components/CompetencyPlaylistForm/CompetencyPlaylistForm";
import { useDispatch } from "react-redux";
import { fetchRecordedContacts } from "../../../../store/RecordedContacts/recordedContactsThunks";

const DetailPanelContent = ({ row, filterModel, sortModel, searchQuery }) => {
  const apiRef = useGridApiContext();
  const dispatch = useDispatch();
  const theme = useTheme();
  const navigate = useNavigate();
  const [openCompetencyPlaylistForm, setOpenCompetencyPlaylistForm] =
    useState(false);

  const handleClose = () => {
    apiRef.current.toggleDetailPanel(row.id);
  };

  const handleCreateCompetencyPlaylist = () => {
    setOpenCompetencyPlaylistForm(true);
  };

  const playlists = row.playlists || [];

  return (
    <Box sx={{ p: 2, position: "relative" }}>
      {/* Close button */}
      <IconButton
        onClick={handleClose}
        size="small"
        sx={{ position: "absolute", top: 15, right: 8, color: theme.palette.text.primary }}
      >
        <CloseIcon />
      </IconButton>

      {/* Header row: title + action */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          pr: 5,
        }}
      >
        <h4 style={{ margin: 0 }}>Associated Playlists ({playlists.length})</h4>
        <Button
          variant="outlined"
          size="small"
          onClick={handleCreateCompetencyPlaylist}
        >
          Create Competency Playlist
        </Button>
      </Box>

      {/* Playlist table */}
      {playlists.length === 0 ? (
        <p style={{ paddingLeft: "8px" }}>
          No playlists linked to this contact.
        </p>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={thStyle}>Created</th>
              <th style={thStyle}>Name</th>
              <th style={thStyle}>Description</th>
              <th style={thStyle}>Type</th>
              <th style={thStyle}>Reviewed At</th>
              <th style={thStyle}>Start Date</th>
              <th style={thStyle}>End Date</th>
              <th style={thStyle}>Status</th>
              <th style={thStyle}></th> {/* Action column */}
            </tr>
          </thead>
          <tbody>
            {playlists.map((playlist) => (
              <tr key={playlist.id}>
                <td style={tdStyle}>{playlist.inserted}</td>
                <td style={tdStyle}>{playlist.name}</td>
                <td style={tdStyle}>{playlist.description || "N/A"}</td>
                <td style={tdStyle}>{playlist.type || "N/A"}</td>
                <td style={tdStyle}>
                  {playlist.reviewedAt || "not_yet_reviewed"}
                </td>
                <td style={tdStyle}>{playlist.startTime || "N/A"}</td>
                <td style={tdStyle}>{playlist.endTime || "N/A"}</td>
                <td style={tdStyle}>{playlist.status || "N/A"}</td>
                <td style={{ ...tdStyle, textAlign: "center" }}>
                  <Tooltip title="View Playlist">
                    <IconButton
                      size="small"
                      onClick={() =>
                        navigate(`/playlists/${playlist.id}`, {
                          state: { name: playlist.name },
                        })
                      }
                      sx={{  color: theme.palette.text.primary }}
                    >
                      <ChevronRightIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* SideModal for creating a Competency Playlist */}
      <SideModal
        open={openCompetencyPlaylistForm}
        onClose={() => setOpenCompetencyPlaylistForm(false)}
        title={`Create Competency Playlist for ${row.fullName}`}
      >
        <CompetencyPlaylistForm
          row={row}
          onSubmit={(data) => {
            setOpenCompetencyPlaylistForm(false);
            dispatch(
              fetchRecordedContacts({
                page: 1,
                filters: filterModel.items.filter(
                  (filter) => filter.value !== undefined && filter.value !== ""
                ),
                sortModel: sortModel,
                search: searchQuery,
              })
            );
          }}
        />
      </SideModal>
    </Box>
  );
};

const thStyle = {
  borderBottom: "1px solid #ddd",
  padding: "8px",
  textAlign: "left",
};

const tdStyle = {
  padding: "8px",
  borderBottom: "1px solid #eee",
};

export default DetailPanelContent;
